import { extendTailwindMerge } from 'tailwind-merge';

const customTwMerge = extendTailwindMerge({
  classGroups: {
    text: [
      'text-headline20',
      'text-headline24',
      'text-title20',
      'text-label14',
      'text-label16',
      'text-label18',
      'text-label20',
      'text-body10',
      'text-body12',
      'text-body14',
      'text-body16',
      'text-body18',
      'displaySm',
      'displayMd',
      'displayLg',
      'otp28',
    ],
  },
});

export default customTwMerge;
